import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/supabase";
import type { UsageRange } from "@/lib/api/queryKeys";

export type UsageEventRow =
  Database["public"]["Tables"]["ai_usage_events"]["Row"];

const RANGE_DAYS: Record<UsageRange, number | null> = {
  "7d": 7,
  "30d": 30,
  "90d": 90,
  all: null,
};

export async function getUsageEvents(
  client: SupabaseClient,
  range: UsageRange,
): Promise<UsageEventRow[]> {
  let query = client
    .from("ai_usage_events")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(5000);

  const days = RANGE_DAYS[range];
  if (days !== null) {
    const since = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
    query = query.gte("created_at", since);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data ?? []) as UsageEventRow[];
}
